export default function Skeleton({ className = '', height, width }) {
  const style = {};
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  return <div className={`skeleton ${className}`} style={style} />;
}

export function SkeletonText({ lines = 1, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={12} className={i === lines - 1 && lines > 1 ? 'w-2/3' : 'w-full'} />
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="p-5 bg-[var(--color-cream-50)] border border-[var(--color-warm-100)] rounded-[var(--radius-lg)]">
      <Skeleton height={14} className="w-1/3 mb-4" />
      <Skeleton height={28} className="w-2/3 mb-2" />
      <Skeleton height={12} className="w-1/2" />
    </div>
  );
}
